import { render, staticRenderFns } from "./AuthenticationFailed.vue?vue&type=template&id=2cdeb327&scoped=true&"
import script from "./AuthenticationFailed.vue?vue&type=script&lang=js&"
export * from "./AuthenticationFailed.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationFailed.vue?vue&type=style&index=0&id=2cdeb327&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdeb327",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VLayout,
})
